import Button from '@mui/material/Button';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ApplicationModal } from '@/components/organisms/ApplicationModal';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly title: string;
  readonly description: string;
}

export const CryptoCompletedModal: React.FC<Props> = (props: Props): React.ReactElement => {
  const { title, description } = props;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const tr = useTranslator();

  const closePath = React.useMemo((): string => {
    return pathname.replace(/\/deposit\/completed$/, '');
  }, [pathname]);

  const onClose = React.useCallback((): void => {
    navigate(closePath, { replace: true });
  }, [navigate, closePath]);

  return (
    <ApplicationModal title={title} description={description} variant="prominent" onClose={onClose}>
      <Button variant="dark" fullWidth={true} onClick={onClose}>
        {tr('DONE')}
      </Button>
    </ApplicationModal>
  );
};
